export var DEFAULT_VALUE = 'This is a default value';
